import { CheckCircle2, CircleAlert, X } from "lucide-react";

type Props = { message: string; kind?: "success" | "error"; onClose: () => void };

export function Toast({ message, kind = "success", onClose }: Props) {
  return (
    <div className={`toast ${kind}`} role="status">
      {kind === "success" ? <CheckCircle2 /> : <CircleAlert />}
      <span>{message}</span>
      <button className="icon-plain" type="button" aria-label="Закрыть" onClick={onClose}><X /></button>
    </div>
  );
}

